import { createNodesFromHTML } from "./helpers";

(function() {
    let buscador = document.getElementById("buscador");
    let resultado = document.getElementById("resultado");
    let listado = resultado.querySelector("[data-resultado]");
    let cerrar = resultado.querySelector(".cerrar");
    let filtro = {};

    buscador.addEventListener("keyup", () => {
        let texto = buscador.querySelector("input[name=texto]").value;

        if (texto.length < 3) {
            resultado.classList.add("hidden");
            return;
        }

        filtro.texto = texto;
        // actualizar();
        debounced();
        resultado.classList.remove("hidden");
    })

    cerrar.addEventListener("click", () => {
        listado.innerHTML = '';
        resultado.classList.add("hidden");
    });

    let actualizar = () => {
        NProgress.start();
        listado.innerHTML = '';

        let pmts = {
            texto: filtro.texto,
            v: new Date().getTime()
        };

        let ruta = buscador.getAttribute("action")

        axios.get(ruta, {params: pmts})
            .then(function (response) {

                let nodes = createNodesFromHTML(response.data);
                nodes.forEach(
                    function(currentValue, currentIndex, listObj) {
                        listado.appendChild(currentValue);
                    }
                );

                buscador.dispatchEvent(new Event('buscador'));
            })
            .catch(function (error) {
                console.log("-> error", error);
            })
            .finally(function () {
                NProgress.done();
            });
    }

    let debounced = _.debounce(actualizar, 250);
})();
